var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImeiBarcodeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3573_1077",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3573_1077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.84668 18.6535V5.73047H3.69268V18.6535H1.84668ZM4.61593 18.6535V5.73047H6.46193V18.6535H4.61593ZM7.38518 18.6535V5.73047H8.30818V18.6535H7.38518ZM10.1542 18.6535V5.73047H12.0004V18.6535H10.1542ZM12.9234 18.6535V5.73047H15.6927V18.6535H12.9234ZM16.6157 18.6535V5.73047H17.5389V18.6535H16.6157ZM19.3849 18.6535V5.73047H22.1542V18.6535H19.3849Z",
    fill: "#57606A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImeiBarcodeIcon);
export default __webpack_public_path__ + "static/media/imei-barcode-icon.a68287bd93afae04efb2d7e38facf690.svg";
export { ForwardRef as ReactComponent };